import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import { data } from 'jquery';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'PRODUTO_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'PRODUTO_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('produtoForm', registro)
    ];
}

export function getLista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/produto${getState().auth.usuario.id_vendedor ? `?id_usuario=${getState().auth.usuario.id}` : ''}`)
		.then(resp => {			
			dispatch({
		        type: 'PRODUTO_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaImagens(registro) {
	return (dispatch, getState) => {

		dispatch({
			type: 'PRODUTO_IMAGENS_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_URL}/produto/imagens?id_produto=${registro.id_produto}`)
		.then(resp => {
			dispatch({
		        type: 'PRODUTO_IMAGENS_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/produto`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/produto`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/produto?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaCidade() {
    const request = axios.get(`${consts.API_URL}/cidade/listarSelect`);
    return {
        type: 'PRODUTO_CIDADE_LISTADO',
        payload: request
    };
}

export function getLinkAcesso(preco) {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/produto/token?preco=true${getState().auth.usuario.id_vendedor ? `&id_usuario=${getState().auth.usuario.id}` : ''}`)
		.then(resp => {
			dispatch({
		        type: 'PRODUTO_LINK_COM_PRECO_GERADO',
		        payload: `${consts.URL}/link/catalogo/produto?key=${resp.data}`
		    });
		}).catch(e => {
			setErroAPI(e);
		});
		axios.get(`${consts.API_URL}/produto/token${getState().auth.usuario.id_vendedor ? `?id_usuario=${getState().auth.usuario.id}` : ''}`)
		.then(resp => {
			dispatch({
		        type: 'PRODUTO_LINK_SEM_PRECO_GERADO',
		        payload: `${consts.URL}/link/catalogo/produto?key=${resp.data}`
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}